import React, { Component } from 'react'
//import demo from "../akshay.jpg"
import axios from "axios";
import NavFormProfile from './NavFormProfile';
import { Link } from "react-router-dom";
import Path from "./config";
import Moment from 'moment';
import BtnFiveHundread from './BtnFiveHundread';

export class Fullbiodata extends Component {
    constructor(props) {
        super(props);

        this.state = {

            sbg_first_name: '',
            sbg_middle_name: '',
            sbg_last_name: '',
            sbg_mulgav: '',
            sbg_sex: '',
            sbg_bloodgroup_id: '',
            sbg_birth_name: '',
            sbg_birth_place: '',
            sbg_birth_date: '',
            sbg_birth_time: '',
            sbg_skin_complexion_id: '',
            sbg_zodiac_signs_id: '',
            sbg_height_id: '',
            sbg_gotra_id: '',
            sbg_mama_kul: '',
            sbg_mama_place: '',
            sbg_marital_status_id: '',
            sbg_handicapped: '',
            sbg_mangal_status_id: '',
            sbg_birth_year: '',
            sbg_birth_month: '',
            userId: null,
            sbg_unmarried_brother: "",
            sbg_married_brother: "",
            sbg_unmarried_sister: "",
            sbg_married_sister: "",
            sbg_mother_full_name: "",
            sbg_father_full_name: "",
            sbg_other_mobile_no1: "",
            sbg_other_mobile_no2: "",
            sbg_parents_address: "",
            sbg_parent_job_buisness: "",
            sbg_education_id: '',
            sbg_other_education: '',
            education: [],
            sbg_job_business_info: "",
            sbg_company_name_address: "",
            sbg_yearly_income: "",
            sbg_expectation: "",
            sbg_post_full_name: "",
            sbg_post_mobileno: "",
            sbg_post_pincode: "",
            sbg_post_state: "",
            sbg_post_district: "",
            sbg_post_taluka: "",
            sbg_post_place: "",
            sbg_post_full_address: "",

            sbgr_person_name: "",
            sbgr_bride_groom_relation: "",
            sbgr_Mobile_no1: "",
            sbgr_Mobile_no2: "",
            sbgr_address: "",
            sbg_list: [],
            sbg_edu_specialization: '',
            sbg_photo: '',
            sbg_status_button: true,
            aaptyaDiv: false,
            ghatspotDiv: false,
            vidhvaDateDiv: false,
            VibhktaDateDiv: false,
            vivahDateDiv: false,
            sbg_status_app: false,
            sbg_gh_marriage_date: "",
            sbg_gh_vibhakta_date: "",
            sbg_gh_divorce_date: "",
            sbg_aptya_girl_no: "",
            sbg_aptya_girl_age: "",
            sbg_aptya_boy_no: "",
            sbg_aptya_boy_age: "",
            sbg_vidhva_date: "",
            sbg_lpid: '',
            showPaymentBtn: false,
            admin: '',
            adminid: '',
            show_courier: false,
            show_pickup: false,
            scc_name: '',
            fk_state_id_suchi: '',
            fk_district_id_suchi: '',
            fk_taluka_id_suchi: '',
            fk_place_id_suchi: '',
            sbg_edit_button: false,
            suchi_curier_fee: '',
            suchi_fee_status: '',
            suchi_nondani_fee: '',
            suchi_suchi_fee: '',
            suchi_suchifee_status: '',

        }
    }
    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId")
        })
        axios.get(Path + 'Show_bride_groom_summery.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;
                let sbg_photo = Path + response.sbg_photo;
                if (response.sbg_office_appoved_status === "0") {
                    this.setState({
                        sbg_status_button: true,
                        sbg_status_app: false
                    })
                } else {
                    this.setState({
                        sbg_status_button: false,
                    })
                    if (response.sbg_admin_approved_status === "0") {
                        this.setState({
                            sbg_edit_button: true,
                            sbg_status_app: true
                        })
                    }
                    else {
                        this.setState({
                            sbg_edit_button: false,
                            sbg_status_app: false
                        })
                    }
                }
                if (response.sbg_suchi_delivery_type === '0') {
                    this.setState({
                        show_courier: true,
                        show_pickup: false
                    })
                } else if (response.sbg_suchi_delivery_type === '1') {
                    this.setState({
                        show_courier: false,
                        show_pickup: true
                    })
                }
                if (response.sbg_marital_status === "1") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: false,
                        vivahDateDiv: false,
                    })
                }
                else if (response.sbg_marital_status === "2") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status === "3") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: true,
                        VibhktaDateDiv: false,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status === "4") {
                    this.setState({
                        aaptyaDiv: true,
                        ghatspotDiv: false,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                else if (response.sbg_marital_status === "5") {
                    this.setState({
                        aaptyaDiv: false,
                        ghatspotDiv: true,
                        vidhvaDateDiv: false,
                        VibhktaDateDiv: true,
                        vivahDateDiv: true,
                    })
                }
                let date = Moment(response.sbg_birth_date).format('DD-MM-YYYY');
                if (response.sbg_lpid_status === "1") {
                    this.setState({
                        enterId: false,
                        showInfo: true,
                    })
                }
                if (response.sbg_payment_amount === "") {
                    this.setState({
                        showPaymentBtn: true,
                    })
                }
                else {
                    this.setState({
                        showPaymentBtn: false,
                    })
                }
                this.setState({
                    sbg_first_name: response.sbg_first_name,
                    sbg_middle_name: response.sbg_middle_name,
                    sbg_last_name: response.sbg_last_name,
                    sbg_mulgav: response.sbg_mulgav,
                    sbg_sex: response.sbg_sex,
                    sbg_bloodgroup_id: response.sbg_bloodgroup_id,
                    sbg_birth_name: response.sbg_birth_name,
                    sbg_birth_place: response.sbg_birth_place,
                    sbg_birth_date: date,
                    sbg_birth_time: response.sbg_birth_time,
                    sbg_skin_complexion_id: response.sbg_skin_complexion_id,
                    sbg_zodiac_signs_id: response.sbg_zodiac_signs_id,
                    sbg_height_id: response.sbg_height_id,
                    sbg_gotra_id: response.sbg_gotra_id,
                    sbg_mama_kul: response.sbg_mama_kul,
                    sbg_mama_place: response.sbg_mama_place,
                    sbg_marital_status_id: response.sbg_marital_status_id,
                    sbg_handicapped: response.sbg_handicapped,
                    sbg_mangal_status_id: response.sbg_mangal_status_id,
                    sbg_property_detail: response.sbg_property_detail,
                    sbg_education_id: response.sbg_education_id,
                    sbg_other_education: response.sbg_other_education,
                    sbg_photo: sbg_photo,
                    sbg_unmarried_brother: response.sbg_unmarried_brother,
                    sbg_married_brother: response.sbg_married_brother,
                    sbg_unmarried_sister: response.sbg_unmarried_sister,
                    sbg_married_sister: response.sbg_married_sister,
                    sbg_mother_prifix: response.sbg_mother_prifix,
                    sbg_father_prifix: response.sbg_father_prifix,
                    sbg_mother_full_name: response.sbg_mother_full_name,
                    sbg_father_full_name: response.sbg_father_full_name,
                    sbg_other_mobile_no1: response.sbg_other_mobile_no1,
                    sbg_other_mobile_no2: response.sbg_other_mobile_no2,
                    sbg_parents_address: response.sbg_parents_address,
                    sbg_parent_job_buisness: response.sbg_parent_job_buisness,
                    sbg_job_business_info: response.sbg_job_business_info,
                    sbg_company_name_address: response.sbg_company_name_address,
                    sbg_yearly_income: response.sbg_yearly_income,
                    sbg_expectation: response.sbg_expectation,
                    sbg_post_full_name: response.sbg_post_full_name,
                    sbg_post_mobileno: response.sbg_post_mobileno,
                    sbg_post_pincode: response.sbg_post_pincode,
                    sbg_post_state: response.sbg_post_state,
                    sbg_post_district: response.sbg_post_district,
                    sbg_post_taluka: response.sbg_post_taluka,
                    sbg_post_place: response.sbg_post_place,
                    sbg_post_full_address: response.sbg_post_full_address,
                    sbg_edu_specialization: response.sbg_edu_specialization,
                    sbg_gh_marriage_date: Moment(response.sbg_gh_marriage_date).format('DD/MM/YYYY'),
                    sbg_gh_vibhakta_date: Moment(response.sbg_gh_vibhakta_date).format('DD/MM/YYYY'),
                    sbg_gh_divorce_date: Moment(response.sbg_gh_divorce_date).format('DD/MM/YYYY'),
                    sbg_aptya_girl_no: response.sbg_aptya_girl_no,
                    sbg_aptya_girl_age: response.sbg_aptya_girl_age,
                    sbg_aptya_boy_no: response.sbg_aptya_boy_no,
                    sbg_aptya_boy_age: response.sbg_aptya_boy_age,
                    sbg_vidhva_date: Moment(response.sbg_vidhva_date).format('DD/MM/YYYY'),
                    sbg_lpid_status: response.sbg_lpid_status,
                    sbg_payment_amount: response.sbg_payment_amount,
                    scc_name: response.scc_name,
                    fk_state_id_suchi: response.fk_state_id_suchi,
                    fk_district_id_suchi: response.fk_district_id_suchi,
                    fk_taluka_id_suchi: response.fk_taluka_id_suchi,
                    fk_place_id_suchi: response.fk_place_id_suchi
                })
            }.bind(this))

        axios.get(Path + 'Suchi_bride_groom_relatives_view.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                this.setState({ sbg_list: response.data.relatives_list })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

        axios.get(Path + 'suchi_fee_manage_view.php')
            .then(function (response) {
                // console.log(response.data)
                this.setState({
                    suchi_curier_fee: response.data.suchi_curier_fee,
                    suchi_fee_status: response.data.suchi_fee_status,
                    suchi_nondani_fee: response.data.suchi_nondani_fee,
                    suchi_suchi_fee: response.data.suchi_suchi_fee,
                    suchi_suchifee_status: response.data.suchi_suchifee_status,
                    amount: response.data.suchi_nondani_fee
                })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    }

    lpidHandler = (e) => {
        this.setState
            ({ sbg_lpid_status: e.target.value }, () => {
                if (this.state.sbg_lpid_status === "yes") {
                    this.setState({
                        enterId: true,
                        showInfo: false
                    })
                }
                else {
                    this.setState({
                        enterId: false,
                        showInfo: true
                    })
                }
            })
    }

    valHandler = (e) => {

        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_lpid: e.target.value })
        }
    }

    submitLpid = () => {
        let typee = "lpid";

        let tempStr = "sbg_lpid=" + this.state.sbg_lpid +
            "&sbg_id=" + localStorage.getItem("userId") +
            "&type=" + typee

        // console.log("wwwwwwwwwwwwwwwwwwwwwwww",tempStr)
        axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                if (response.data.status === "updated") {
                    alert("LP ID Updated....")
                    // this.props.history.push(`/FormProfile/`);

                } else {

                }

            })

    }
    changeFormStatus = (e) => {
        let user_status = "1";
        let r = window.confirm("तुमची प्रोफाईल फायनल सबमिशन साठी पाठवायची आहे ना, आता यानंतर पुन्हा बदल करणे शक्य नाही. बदल करायचे असल्यास ऑफिस ला संपर्क करावा");
        if (r === true) {
            let tempStr = "&sbg_id=" + this.state.userId + "&user_status=" + user_status

            axios.post(Path + `Suchi_bride_groom_change_status_user.php?` + tempStr)
                .then(function (response) {

                    if (response.data.result === "Updated") {
                        this.setState({
                            sbg_status_app: true
                        })
                    }
                    window.location.reload(false);
                    this.props.history.push(`/FormProfile/FinalBiodata`);
                }
                    .bind(this)
                )
        }

        else {
        }
    }

    editForm = (e) => {
        let user_status = "0";

        let tempStr = "&sbg_id=" + this.state.userId + "&user_status=" + user_status

        axios.post(Path + `Suchi_bride_groom_change_status_user.php?` + tempStr)
            .then(function (response) {

                if (response.data.result === "Updated") {
                    this.setState({
                        sbg_status_app: true
                    })
                }
                window.location.reload(false);
                this.props.history.push(`/FormProfile/FinalBiodata`);
            }
                .bind(this)
            )
    }

    suchiCharges = (e) => {
        this.handlePay(e, this.state.suchi_suchi_fee, 'suchi', this.state.suchi_suchi_fee, this.state.suchi_curier_fee)
    }
    handlePay = async (e, amt, feeType, suchi_suchi_fee, suchi_curier_fee) => {
        var options = {
            key: "rzp_live_vZAapBhrz3PXrW", // Enter the Key ID generated from the Dashboard
            amount: amt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "Leva Shubhmangal Business Suchi", //your business name
            description: "Thank You",
            image: '',
            handler: async function (response) {
                // console.log(response);
                if (response.razorpay_payment_id) {
                    //console.log(response)
                    let typee = "Payment";

                    let tempStr = "sbg_payment_amount=" + amt +
                        "&sbg_id=" + localStorage.getItem("userId") +
                        "&type=" + typee +
                        "&feeType=" + feeType +
                        "&suchi_suchi_fee=" + suchi_suchi_fee +
                        "&suchi_curier_fee=" + suchi_curier_fee +
                        "&razorpay_payment_id=" + response.razorpay_payment_id;

                    axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                        .then(function (response) {
                            //  console.log(response)
                            if (response.data.status === "updated") {
                                // window.location.replace(`/Fullbiodata`);
                                window.location.reload(false);
                            } else {
                                alert("Payment not Received");
                            }
                        }.bind(this))
                }
            },
            prefill: {
                name: ' Suchi User', //your customer's name
                email: '',
                contact: '',
            },
            modal: {
                ondismiss() {
                    // Handle what happens when the customer dismisses the payment form without completing the payment. This may
                    // involve re-enabling a "pay now" button if you disable it when it's clicked.
                    //  window.location.replace("/FormProfile/SummaryDetails");
                },
            },
            notes: {
                address: "Razorpay Corporate Office",
            },
            theme: {
                color: "#3399cc",
            },
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.open();
        rzp1.on("payment.failed", function (response) {
            //razorpay_payment_id
            // localStorage.setItem("bf_payment_status", "Unpaid");
            // this.props.history.push(`/FormProfile/SummaryDetails`);
        });
    };
    render() {
        //console.log(this.state.sbg_status_button);
        let renderTableData =
            this.state.sbg_list.map((slist, index) => {
                const { sbgr_id, sbgr_prifix, sbgr_person_name, sbgr_bride_groom_relation, sbgr_Mobile_no1, sbgr_Mobile_no2, sbgr_address } = slist //destructuring
                return (
                    <tr key={sbgr_id}>

                        <td>{sbgr_prifix}. {sbgr_person_name}</td>
                        <td>{sbgr_bride_groom_relation}</td>
                        <td>{sbgr_Mobile_no1}</td>
                        <td>{sbgr_Mobile_no2}</td>
                        <td>{sbgr_address}</td>
                        <td>
                        </td>
                    </tr>
                )
            })
        return (
            <>
                {this.state.sbg_status_button ?
                    <NavFormProfile /> : null}
                <div className=" m-5 border border-secondary bg-white p-5 lh-base">
                    <div className="row g-3  ">

                        {this.state.suchi_fee_status == '1' ?
                            (this.state.showPaymentBtn &&
                                <div div className="col-md-4 text-lg-center ">
                                    <span className="blinking" >सूची ची फी भरण्यासाठी खालील बटणावर क्लिक करावे.</span>
                                    {/* <BtnFiveHundread/> */}

                                    <button type='button' className='payNowBtn' onClick={(e) => this.suchiCharges(e)}>Pay Now</button>
                                </div>
                            )
                            : ''}


                    </div>



                    <div className="row g-3 ">
                        {this.state.sbg_status_button ?
                            <div className="row text-primary mb-5">
                                <div className="col-md-8"><br /><br />
                                    टीप :- <br />
                                    कृपया आपली संपूर्ण माहिती पुन्हा एकदा चेक करावी ,
                                    बदल करायचे असल्यास आताच करून घ्यावे ,
                                    सर्व माहिती बरोबर असेल तर SUBMIT FOR APPROVAL  वर क्लिक करावे .
                                </div>
                                <div className="col-md-4  text-lg-right">
                                    <br /><br />
                                    <button type="button" class="btn btn-danger" onClick={() => this.changeFormStatus()}>SUBMIT FOR APPROVAL</button>

                                </div>
                            </div>
                            : null}
                        <div className='row mt-4'>
                            {this.state.sbg_status_app ?
                                <div className="col-md-8  row text-success mb-5">
                                    <div className="col-md-12">
                                        <h4>   तुमची प्रोफाईल आमच्या अडमीन कडे approval साठी यशस्वीरित्या पाठविण्यात आलेली आहे</h4>
                                    </div>

                                </div>
                                : null}
                            {this.state.sbg_edit_button ?
                                <div className="col-md-4  text-lg-right ">

                                    <button type="button" class="btn btn-danger" onClick={() => this.editForm()}>Edit</button>
                                </div> : ''}
                        </div>
                        <div className="row">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >वैयक्तिक माहिती </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">वधू वराचे नाव </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_first_name + " " + this.state.sbg_middle_name + " " + this.state.sbg_last_name} </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3"> मुळगाव  </div>
                                <div className="col-md-1">  :  </div>
                                <div className="col-md-6">  {this.state.sbg_mulgav}   </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">लिंग</div>
                                <div className="col-md-1">: </div>
                                <div className="col-md-6">{this.state.sbg_sex}  </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    रक्त गट
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_bloodgroup_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_birth_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म ठिकाण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_birth_place}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म दिनांक
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_birth_date}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म वेळ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">{this.state.sbg_birth_time}</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    रंग
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_skin_complexion_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जन्म राशी
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_zodiac_signs_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    उंची
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_height_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    गोत्र
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_gotra_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मामकुळ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mama_kul}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मामाचे गाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mama_place}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3"> वैवाहिक स्थिती  </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_marital_status_id}</div>
                            </div>
                            {this.state.aaptyaDiv ? <div className="row">

                                <div className="col-md-3"> अपत्य</div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">
                                    <table className="bg-white table" >
                                        <tbody>
                                            <tr >
                                                <td className="bg-gray ">अपत्य</td>
                                                <td className="">संख्या</td>
                                                <td className="">वय</td>
                                            </tr>
                                            <tr>
                                                <td className="bg-gray">मुलगा</td>
                                                <td>{this.state.sbg_aptya_boy_no}</td>
                                                <td>{this.state.sbg_aptya_boy_age} </td>
                                            </tr>
                                            <tr>
                                                <td className="bg-gray"> मुलगी</td>
                                                <td>{this.state.sbg_aptya_girl_no}</td>
                                                <td>{this.state.sbg_aptya_girl_age} </td>
                                            </tr>
                                        </tbody>
                                    </table></div>
                            </div>

                                : null}

                            {this.state.vivahDateDiv ? <div className="row">
                                <div className="col-md-3"> विवाह तारीख </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_gh_marriage_date}</div>
                            </div>
                                : null}

                            {this.state.VibhktaDateDiv ? <div className="row">
                                <div className="col-md-3"> विभक्त होण्याची तारीख </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_gh_vibhakta_date}</div>
                            </div>
                                : null}

                            {this.state.ghatspotDiv ? <div className="row">
                                <div className="col-md-3"> घटस्फोटाची तारीख  </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_gh_divorce_date}</div>
                            </div>
                                : null}

                            {this.state.vidhvaDateDiv ? <div className="row">
                                <div className="col-md-3"> विधवा / विधुर होण्याची   तारीख  </div>
                                <div className="col-md-1"> : </div>
                                <div className="col-md-6">{this.state.sbg_vidhva_date}</div>
                            </div>
                                : null}









                            <div className="row">
                                <div className="col-md-3">
                                    अपंगत्व / शाररिक दोष
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_handicapped}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मंगळ दोष
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mangal_status_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    अपेक्षा
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_expectation}
                                </div>
                            </div>


                        </div>
                        <div className="col-md-4">
                            <img src={this.state.sbg_photo} alt="test" className="img-fluid"></img>
                        </div>
                    </div>

                    <div className="row g-3 mt-3">
                        <div className="row m-2">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >शैक्षणिक माहिती  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/EducationInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    शिक्षणाची कॅटेगिरी
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_education_id}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    शिक्षण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_edu_specialization}
                                </div>
                            </div>


                        </div>

                    </div>

                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >उत्पन्न विषयी माहिती  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/IncomeInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    कंपनी चे नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_job_business_info}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_company_name_address}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    वार्षिक उत्पन्न
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_yearly_income}
                                </div>
                            </div>


                        </div>

                    </div>
                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >कौटुंबिक माहिती</h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/FamilyInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">


                            <div className="row">
                                <div className="col-md-3">
                                    अविवाहित भाऊ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_unmarried_brother}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    विवाहित भाऊ
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_married_brother}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    अविवाहित बहीण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_unmarried_sister}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    विवाहित बहीण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_married_sister}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    आईचे पूर्ण नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_mother_prifix}. {this.state.sbg_mother_full_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    वडिलांचे पूर्ण नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_father_prifix}. {this.state.sbg_father_full_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मोबाइल नंबर 1
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_other_mobile_no1}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मोबाइल नंबर 2
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_other_mobile_no2}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    आई वडिलांचा पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_parents_address}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    व्यवसाय
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_parent_job_buisness}
                                </div>
                            </div>




                        </div>

                    </div>


                    <div className="row g-3 mt-3">
                        <div className="row mt-3">
                            <div className="col-md-8 mt-3 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >संपर्कासाठी ओळखीच्या प्रतिष्ठित व्यक्तींचे नावे  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/ContactInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-12">


                            <table className=" table table-hover">
                                <thead>
                                    <tr>

                                        <th scope="col">व्यक्तीचे संपूर्ण नाव</th>
                                        <th scope="col">वधू वरसोबत असलेले नाते</th>
                                        <th scope="col">मोबाइल नंबर 1</th>
                                        <th scope="col">मोबाइल नंबर 2</th>
                                        <th scope="col">पत्ता</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {renderTableData}
                                </tbody>
                            </table>





                        </div>

                    </div>


                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >स्थावर मालमत्ता  </h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/AssetInfo`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    मालमत्तेचे विवरण
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_property_detail}
                                </div>
                            </div>




                        </div>

                    </div>


                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" > पत्ता</h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/Paddress`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">
                                    पूर्ण नाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_full_name}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    मोबाईल क्रमांक
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_mobileno}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    पिन कोड
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_pincode}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">

                                    राज्य
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_state}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जिल्हा
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_district}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    तालुका
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_taluka}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    गाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_place}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    संपूर्ण पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.sbg_post_full_address}
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="row g-3 mt-3">
                        <div className="row m-3">
                            <div className="col-md-8 d-flex justify-content-center text-primary font-weight-bold">
                                <h4 className="px-3 mx-auto" >सूचि वाटप पत्ता</h4>
                            </div>
                            {this.state.sbg_status_button ? <div className="col-md-4 d-flex text-xl-right">
                                <Link to={`/FormProfile/PostAddress`} className="text-warning font-weight-bold">
                                    <button type="button" className="btn btn-warning">EDIT</button> </Link>
                            </div> : null}
                        </div>
                        {this.state.show_pickup ? <div className="col-md-8">

                            <div className="row">
                                <div className="col-md-3">

                                    राज्य
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.fk_state_id_suchi}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    जिल्हा
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.fk_district_id_suchi}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    तालुका
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.fk_taluka_id_suchi}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    गाव
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.fk_place_id_suchi}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    पत्ता
                                </div>
                                <div className="col-md-1">
                                    :
                                </div>
                                <div className="col-md-6">
                                    {this.state.scc_name}
                                </div>
                            </div>


                        </div> : ''}
                    </div>
                </div>

            </>
        )
    }
}

export default Fullbiodata